import Form from 'components/Form';
import { IFormValues, IFormRegister } from 'routes/Main/type';
import { Fragment } from 'react';
import { Stack } from '@mui/material';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormRegister {
  disabled?: boolean;
}

const Judgement = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="판단력" />

      <RowContainer xs={12}>
        <RowContent title="판단력" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('judgement.radio.value')}
              onChange={v => setValue('judgement.radio.value', v)}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Judgement;
